import clsx from 'clsx'
import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { getGenderTitle } from 'type/gender'
import css from './GenderButton.module.scss'

type Props = {
  gender: string
}

export const GenderButton = observer(({ gender }: Props) => {
  const demo = useDemo()
  const { tsum, form } = demo
  const active = form.gender === gender
  const className = clsx(css.button, tsum ? css.tsum : css.regular, active && css.active)

  const onClick = useLatestCallback(() => {
    form.gender = gender
  })

  return <Button className={className} action={onClick}>
    <Typo accent>
      {getGenderTitle(gender)}
    </Typo>
  </Button>
})
